/*
  Theme-styled currency switcher for the Beast Currency Converter (Doubly) app.
  The app renders a hidden <select name="doubly-currencies"> inside .doubly-wrapper
  and exposes its API as window.DoublyGlobalCurrency; this element builds the theme
  dropdown from the select's options and drives the conversion through that API.
*/
if (!customElements.get('doubly-currency-switcher')) {
  class DoublyCurrencySwitcher extends HTMLElement {
    connectedCallback() {
      this.tries = 0;
      this.waitForApp();

      // With hover trigger the menu is already open when clicked; keep it open instead of toggling it shut
      this.addEventListener('click', (event) => {
        const summary = event.target.closest('summary');
        const details = summary && summary.parentElement;
        if (details && details.trigger === 'hover' && details.open && !theme.config.isTouch) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    }

    get selects() {
      return Array.from(document.querySelectorAll('select[name="doubly-currencies"]'));
    }

    get currentCurrency() {
      return (window.DoublyGlobalCurrency && DoublyGlobalCurrency.currentCurrency) || this.selects[0].value;
    }

    waitForApp() {
      if (this.selects.length && window.DoublyGlobalCurrency) return this.render();
      if (++this.tries > 200) return;

      setTimeout(() => this.waitForApp(), 100);
    }

    render() {
      const itemClass = this.getAttribute('item-class') || 'reversed-link';

      this.querySelectorAll('[data-doubly-list]').forEach((list) => {
        list.innerHTML = '';
        Array.from(this.selects[0].options).forEach((option) => {
          const li = document.createElement('li');
          li.className = 'opacity-0';
          li.innerHTML = `<p><a class="${itemClass} flex items-center gap-2" href="#" data-value="${option.value}" data-no-instant>`
            + `<span class="doubly-flag shrink-0"><span class="flags flags-${option.dataset.country}"></span></span>`
            + `<span></span></a></p>`;
          const link = li.querySelector('a');
          link.lastElementChild.textContent = `${option.textContent} (${option.value})`;
          link.title = link.lastElementChild.textContent;
          link.addEventListener('click', this.onItemClick.bind(this));
          list.appendChild(li);
        });
      });

      this.update(this.currentCurrency);
    }

    onItemClick(event) {
      event.preventDefault();

      const currency = event.currentTarget.getAttribute('data-value');
      this.selects.forEach((select) => select.value = currency);
      DoublyGlobalCurrency.convertAll(currency);
      // The app listens for document "change" to re-convert late-loaded prices and show its cart message
      this.selects[0].dispatchEvent(new Event('change', { bubbles: true }));

      document.querySelectorAll('doubly-currency-switcher').forEach((switcher) => switcher.update(currency));

      const details = this.querySelector('details[open]');
      if (details) details.open = false;
      this.querySelectorAll('modal-element[open]').forEach((modal) => modal.hide());
    }

    update(currency) {
      if (!this.selects.length) return;

      const option = Array.from(this.selects[0].options).find((opt) => opt.value === currency);
      if (!option) return;

      this.querySelectorAll('[data-doubly-current]').forEach((el) => el.textContent = currency);
      this.querySelectorAll('[data-doubly-flag]').forEach((el) => el.className = `flags flags-${option.dataset.country}`);
      this.querySelectorAll('[data-doubly-list] a').forEach((link) => {
        const active = link.getAttribute('data-value') === currency;
        link.classList.toggle('active', active);
        link.classList.toggle('pointer-events-none', active);
        active ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current');
      });
    }
  }
  customElements.define('doubly-currency-switcher', DoublyCurrencySwitcher);
}
